import LayerAction from "./LayerAction";
import { fetchJSON, fetchPOST, formatDate } from '../Tools';
import * as routes from './Routes';

export default class PostProcessing {
    protected postActionButtons: NodeListOf<HTMLElement>;

    constructor() {
        this.postActionButtons = document.querySelectorAll(
            '.reportwesen-postprocessing .rw-action'
        );
        if (!this.postActionButtons.length) {
            return;
        }
        const _this = this;
        this.postActionButtons.forEach((actionEl: HTMLElement) => {
            actionEl.addEventListener('click', (e) => {
                LayerAction.open(actionEl, async (el) => {
                    if (el.dataset.rwAction === 'cancel') {
                        await fetchPOST(routes.RWStop, {});

                        window.tools.toast('Nachbearbeitung', 'Eintrag wurde angelegt');
                        return false;
                    }
                    return true;
                });
            });
        });
    }
}
